import { usePermissionStore } from '../../stores/permissionStore';
import { useAuthStore } from '../../stores/authStore';
import { isSuperAdmin } from '../../utils/permissions';

/** ¿Puede el usuario usar Nexus? (UI; la API vuelve a comprobarlo). */
export function useNexusAccess(): boolean {
  const role = useAuthStore((s) => s.user?.role ?? '');
  const perms = usePermissionStore((s) => s.permissions);
  return isSuperAdmin(role) || perms.includes('NEXUS_USE') || perms.includes('NEXUS_ADMIN');
}

export const nexusTaskUrl = (projectId: string, taskId: string) => `/nexus?project=${projectId}&task=${taskId}&run=1`;
